import {gql} from '@apollo/client';

export default gql`
  mutation lockStart($input: LockInput!) {
    lockStart(input: $input) {
      success
    }
  }
`;
